export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.otf.86f6a102.woff";